import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  ButtonsContainer,
  CancelButton,
  ConfirmButton,
  Divider,
  Header,
  Paragraph,
  RootWrapper,
  Trademark,
  ModalContainer,
} from './component.styles'
import { ALL, CANCEL_TX, displayText, PENDING, SEND_TX } from './constants'
import YieldIcon from '../YieldIcon/component'
import CloseIcon from 'components/CloseIcon'
import CloseButton from 'components/CloseButton'
import { CustomCheckBox } from '../CustomCheckBox/component'

const SendInvitesDialog = ({
  onCancel,
  onConfirm,
  showIcon,
  userMetaInfo,
  isOpen,
}) => {
  const [isChecked, setIsChecked] = useState({ [ALL]: true })
  const [isDisabled, setIsDisabled] = useState({ [ALL]: false })
  useEffect(() => {
    setIsChecked(getDefaultCheckedStated())
  }, [userMetaInfo])

  useEffect(() => {
    checkIsDisabled()
  }, [isChecked])

  const getCountSection = count => `(${count} user${count > 1 ? 's' : ''})`

  const handleOnChange = e => {
    const { name, checked } = e.target

    setIsChecked(prevState => {
      const newState = { ...prevState }
      if (name === PENDING) {
        // set everything not pending to false
        Object.entries(newState).map(([key, value]) =>
          key === PENDING ? (newState[key] = checked) : (newState[key] = false),
        )
      } else if (name === ALL) {
        // set everything not all to the value of all
        Object.entries(newState).map(([key, value]) =>
          key === PENDING ? (newState[key] = false) : (newState[key] = checked),
        )
      } else {
        newState[name] = checked

        let allNonPendingNonAllAreChecked = true
        for (const role in newState) {
          if (Object.hasOwnProperty.call(newState, role)) {
            if (role === ALL || role === PENDING) {
              continue
            }
            if (
              newState[role] &&
              Object.hasOwnProperty.call(newState, PENDING)
            ) {
              newState.pending = false
            }
            if (!newState[role]) {
              newState.all = false
              allNonPendingNonAllAreChecked = false
            }
          }
        }

        if (allNonPendingNonAllAreChecked) {
          newState.all = true
        }
      }
      return newState
    })
  }

  const checkIsDisabled = () => {
    const disabledState = {}

    if (isChecked[ALL]) {
      for (const role in isChecked) {
        if (Object.hasOwnProperty.call(isChecked, role)) {
          disabledState[role] = !(role === ALL || role === PENDING)
        }
      }
    } else {
      for (const role in isChecked) {
        if (Object.hasOwnProperty.call(isChecked, role)) {
          disabledState[role] = false
        }
      }
    }

    setIsDisabled(disabledState)
  }

  const isSendDisabled = () => {
    for (const role in isChecked) {
      if (isChecked[role]) return false
    }
    return true
  }

  const getDefaultCheckedStated = () => {
    const newCheckedState = {}
    for (const role in userMetaInfo) {
      newCheckedState[role] = role !== PENDING
    }
    return newCheckedState
  }

  return (
    <ModalContainer isModalOpen={isOpen}>
      <RootWrapper>
        <CloseButton
          dataTestId="close-add-user-modal-button"
          onClick={onCancel}
        >
          <CloseIcon />
        </CloseButton>
        {showIcon && <YieldIcon dataTestId="send-invites-dialog-yield-icon" />}
        <Header data-testid="send-invites-dialog-header">
          Notify staff about
          <br />
          Second Step<Trademark>®</Trademark> access
        </Header>
        <Paragraph>Send an email to:</Paragraph>
        {Object.keys(userMetaInfo)
          .sort(a => (a === ALL ? -1 : 0))
          .map(role =>
            role === PENDING ? (
              <Fragment key="pending-fragment">
                <Divider key="send-invite-div" />
                <CustomCheckBox
                  checked={isChecked[role]}
                  key="pending"
                  name={role}
                  onChange={handleOnChange}
                  text={`${displayText[role]} ${getCountSection(
                    userMetaInfo[role],
                  )}`}
                />
              </Fragment>
            ) : (
              <CustomCheckBox
                checked={isChecked[role]}
                isDisabled={isDisabled[role]}
                key={role}
                name={role}
                onChange={handleOnChange}
                text={`${displayText[role]} ${getCountSection(
                  userMetaInfo[role],
                )}`}
              />
            ),
          )}
        <ButtonsContainer>
          <CancelButton
            data-testid="send-invites-dialog-cancel-button"
            onClick={onCancel}
          >
            {CANCEL_TX}
          </CancelButton>
          <ConfirmButton
            data-testid="send-invites-dialog-confirm-button"
            disabled={isSendDisabled()}
            onClick={() => onConfirm(isChecked)}
            type="submit"
          >
            {SEND_TX}
          </ConfirmButton>
        </ButtonsContainer>
      </RootWrapper>
    </ModalContainer>
  )
}

SendInvitesDialog.propTypes = {
  confirmText: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  showIcon: PropTypes.bool,
  userMetaInfo: PropTypes.object,
}

export default SendInvitesDialog
